export const DESKTOP_EXPANDED_ITEM_WIDTH = 644;
export const MAX_DESKTOP_CONTAINER_WIDTH = 1434;
export const MOBILE_ITEM_WIDTH = 223;
export const SPACE_BETWEEN_ITEMS = 16;
